module.exports = __webpack_public_path__ + "static/media/YF01_4.1ea8dfcc.jpg";